import PurposePage from '../en/purpose';
export default PurposePage;